module.exports = __webpack_public_path__ + "images/pages/for_business/sp/btn_1_844e2a551ffba8c8cc92a8601e0183b8.png";